
import {Component, Prop, Vue} from "vue-property-decorator";
import type {IParksConfig} from "@/modules/ParksConfig/interfaces/parks-config.interface";
import {IParkEvent} from "@/modules/ParksConfig/interfaces/park-event.interface";

  @Component({})
  export default class ParkEventsFilters extends Vue {
    @Prop() park: IParksConfig.IPark;

    formModel: IParkEvent.IFilterEvents = {
      enabled: false,
    };

    async addNewEvent() {
      await this.$store.dispatch('parksConfig/addNewParkEvent');
    }

    async setFilters() {
      await this.$store.dispatch('parksConfig/getParkEvents', {
        parkId: this.park.id,
        filters: {
          ...this.formModel,
          enabled: !this.formModel.enabled,
        },
      });
    }
  }
